<template>
  <div>
    <b-card>
      <a :href="previewImageUrl" target="_blank">
        <img :src="previewImageUrl" :style="{ 'max-width': '100%', 'height': 'auto', 'max-height': `${previewHeight}px`}" />
      </a>
    </b-card>

    <uploader
      ref="fileUploader"
      :upload-url="baseUrl + uploadUrl"
      :value-changed="valueChanged"
      :allow-delete="!!previewImageUrl"
      :disabled="disabled"
      @input="onInput"
    />
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService';
import Uploader from './Uploader';

export default {
  name: "ImageUploader",

  props: {
    uploadUrl: {
      type: String,
      default: '/'
    },
    previewHeight: {
      type: Number,
      default: 100
    },
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  components : {
    Uploader
  },

  data() {
    return {
      uploadImageUrl: null
    }
  },

  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    },

    authorizationHeader() {
      return AuthenticationService.authorizationHeader;
    },

    previewImageUrl() {
      return this.uploadImageUrl ? window.URL.createObjectURL(this.uploadImageUrl) : this.value;
    },
  },

  watch: {
    value (newVal, oldVal) {
      if (newVal !== oldVal && !newVal)
      {
        this.$refs?.fileUploader?.reset();
        this.uploadImageUrl = null;
      }
    },
  },
  
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },

    valueChanged(event) {
      this.uploadImageUrl = event?.value?.[0];
      this.$emit('value-changed', event, this.uploadImageUrl);
      if (this.uploadImageUrl)
        this.onInput(event);
    },

    uploadImage() {
      return this.$refs.fileUploader.uploadFile();
    }
  }
}
</script>